import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import GalleryLabelList from './GalleryLabelList';
import CompanyLabelList from './CompanyLabelList';
import DielinePmsColorConfig from './DielinePmsColorConfig';
import useShowCompanyLabelFlag from 'hooks/useShowCompanyLabelFlag';

const ResourceAdminContainer = () => {
  const { t } = useTranslation();

  return (
    <Tabs
      defaultActiveKey="1"
      tabPosition="left"
      style={{ height: '100%', backgroundColor: 'white', paddingTop: 8 }}
    >
      {!useShowCompanyLabelFlag() && (
        <Tabs.TabPane tab={t('platform.resources.tabs.galleryLabels')} key="1">
          <GalleryLabelList />
        </Tabs.TabPane>
      )}
      {useShowCompanyLabelFlag() && (
        <Tabs.TabPane tab={t('platform.resources.tabs.companyLabels')} key="2">
          <CompanyLabelList />
        </Tabs.TabPane>
      )}
      <Tabs.TabPane tab={t('platform.resources.tabs.dielinePmsColor')} key="3">
        <DielinePmsColorConfig />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default ResourceAdminContainer;
